// import

import {styled} from 'goober';
import type {ComponentProps} from 'react';

import type {HomeMainNode} from 'libs/model';
import {Type} from 'modules/Type';

import LogoText from '../../public/logo/text.svg';

import {NotifyForm} from './NotifyForm';
import {Plaque} from './Plaque';

// types

type Props = ComponentProps<typeof Styled> &
HomeMainNode['meta']['splashRegion'];

// component

export function HomeSplash(props: Props) {
  const {headline, subhead, signup, ...rest} = props;

  return (
    <Styled {...rest} data-test="splash">
      <div className="sky">
        <Plaque
          className="head"
          head={(
            <LogoText aria-label="SiteArcade" className="logo" />
          )}
          headline={headline}
          subhead={subhead}
        />

        <div className="call">
          <img alt="tickets" className="tic l" src="/logo/icon.svg" />
          <img alt="tickets" className="tic r" src="/logo/icon.svg" />

          {signup.headline ? (
            <Type className="headline">{signup.headline}</Type>
          ) : null}

          {signup.blurbMark ? (
            <Type className="blurb">{signup.blurbMark}</Type>
          ) : null}

          <NotifyForm
            buttonColor="green"
            buttonText={signup.buttonText}
            className="form"
            groups={signup.mailerliteGroups}
          />
        </div>
      </div>
    </Styled>
  );
}

// styles

const Styled = styled('section')`
  .sky {
    padding: 9rem 3rem;
    background:
      linear-gradient(
        to bottom,
        var(--blue) 0%,
        var(--blue-75) 25%,
        var(--blue-100) 50%,
        var(--white) 100%
      );
  }

  .head {
    margin: 0 auto 6rem;
  }

  .logo {
    width: min(66.666%, 24rem);
    margin-bottom: 0.15vw;
  }

  .call {
    text-align: center;
    margin: 0 auto;
    padding: 0 min(7.5rem, 13.888vw);
    max-width: var(--bp-sm);
    position: relative;
  }

  .tic {
    width: min(9rem, 16.666vw);
    position: absolute;
    top: max(-1.5rem, -2.777vw);
  }

  .l {
    left: -2.5rem;
    transform: rotate(-15deg);
  }

  .r {
    right: -2.5rem;
    transform: scaleX(-1) rotate(-15deg);
  }

  .headline {
    margin-bottom: 0.5rem;
    font-family: var(--font-head);
    letter-spacing: normal;
    font-weight: 500;
  }

  .blurb {
    margin-bottom: 0.5rem;
    font-variation-settings: "wght" 350;
  }

  .form {
    width: 100%;
  }

  @media (max-width: 35.99875em) {
    .tic { display: none; }
    .call { padding: 0; }
  }
`;
